import { render, staticRenderFns } from "./template.html?vue&type=template&id=2c810e12&scoped=true&"
import script from "./SidenaviLine.vue?vue&type=script&lang=ts&"
export * from "./SidenaviLine.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=2c810e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c810e12",
  null
  
)

export default component.exports